$(function(){
  $('.js-field').each(function() {

    var $this = $(this);
    if($this.val() != ''){
    $this.closest('.js-form-item').find('.js-label').fadeOut();
    } else {
      $this.closest('.js-form-item').find('.js-label').fadeIn();
    }
  });
  $('.js-field').blur(function() {
    var $this = $(this);
    if($this.val() != ''){
    $this.closest('.js-form-item').find('.js-label').fadeOut();
    } else {
      $this.closest('.js-form-item').find('.js-label').fadeIn();
    }
  });
  $('.js-field').focus(function() {
    var $this = $(this);
    $this.closest('.js-form-item').find('.js-label').fadeOut();
  });
  $('.js-label').on('click', function() {
    var $this = $(this);
    $this.closest('.js-form-item').find('.js-field').focus();
  });

//table wrap

  $('.page-text table').each(function(){
    let $this = $(this);
    $this.wrap("<div class='table-wrap'></div>")
  })
});

